import { h } from 'preact';
import Store from 'store/store';
import { unpublish } from 'utils/data';
import * as jsonPointer from 'utils/jsonPointer';
import { Modal, toast } from 'utils/modal';
import { getCurrentHubDomain } from 'utils/studioConfig';
import { joinClasses } from 'utils/utils';

import Button from 'components/button/button';
import ContactLink from 'components/contactLink/contactLink';

import s from 'components/unpublish/unpublish.sss';

export default class Unpublish extends Modal {
	s = s;
	title = 'Unpublish movie?';

	constructor(props) {
		super(props);

		this.state = {
			movieData: jsonPointer.get(Store.get().data, this.props.path),
			url: `https://${getCurrentHubDomain()}/`,
			confirmTitle: '',
		};

		this.cancel = this.cancel.bind(this);
		this.unpublish = this.unpublish.bind(this);
	}

	cancel() {
		this.base.close();
	}

	async unpublishRaw() {
		this.setState({ unpublishing: true, error: null });
		try {
			await unpublish(this.props.path, this.state.url);
			toast('Site unpublished!', { icon: 'rocket' });
			this.base.close();
		} catch (err) {
			console.error(err);
			this.setState({ error: { at: new Date(), error: err }, publishing: false });
		}
	}

	async unpublish() {
		return this.unpublishRaw();
	}

	renderContent() {
		const { confirmTitle, error, movieData, url } = this.state;
		const movieTitle = movieData.title || 'this movie';

		const ContactUsLink = () => (
			<ContactLink
				subject="Error while unpublishing content"
				body={[
					`Error unpublishing ${this.props.path} at ${error?.at.toISOString() || Date.now()}\n`,
					`Browser: ${navigator.userAgent}\n`,
					'Error details:',
					error?.error.message,
					error?.error.stack
				].filter(e => e).join('\n') + '\n'}
			>
				contact us
			</ContactLink>
		);

		return (
			<p class={joinClasses(s.content, error && s.hasError)}>
				<div>
					This will unpublish the movie from the site.
				</div>
				<div>
					This will move the movie under the “Archive” tab on listings and it will no longer be accessible to visitors.
				</div>
				<label>
					<div class={s.name}>Redirect to URL</div>
					<input class={s.field} type="text" value={url} onInput={(e) => this.setState({ url: e.target.value })} />
				</label>
				<label>
					<div class={s.name}>To unpublish, type in <span>{movieTitle}</span> below:</div>
					<input class={s.field} type="text" placeholder={movieTitle} value={confirmTitle} onInput={(e) => this.setState({ confirmTitle: e.target.value })} />
				</label>
				<div class={s.error}>
					Sorry, an error occured while publishing your changes. Please try again later or <ContactUsLink /> if the problem persists.
				</div>
			</p>
		);
	}

	renderActions() {
		const { confirmTitle, movieData } = this.state;
		const movieTitle = movieData.title || 'this movie';

		return (
			<div class={this.c('actions')}>
				<Button type="submit" value="CANCEL" key="cancel">Cancel</Button>
				<Button 
					danger 
					disabled={confirmTitle !== movieTitle}
					onClick={this.unpublish} 
					key="unpublish"
				>
					Unpublish
				</Button>
			</div>
		);
	}
}